var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99994 2.99988C9.99994 3.55216 9.55222 3.99988 8.99994 3.99988L4.99994 3.99988C4.73472 3.99988 4.48037 4.10523 4.29283 4.29277C4.1053 4.48031 3.99994 4.73466 3.99994 4.99988L3.99994 18.9999C3.99994 19.2651 4.1053 19.5194 4.29283 19.707C4.48037 19.8945 4.73472 19.9999 4.99994 19.9999H8.99994C9.55222 19.9999 9.99994 20.4476 9.99994 20.9999C9.99994 21.5522 9.55222 21.9999 8.99994 21.9999H4.99994C4.20429 21.9999 3.44123 21.6838 2.87862 21.1212C2.31601 20.5586 1.99994 19.7955 1.99994 18.9999L1.99994 4.99988C1.99994 4.20423 2.31601 3.44117 2.87862 2.87856C3.44123 2.31595 4.20429 1.99988 4.99994 1.99988L8.99994 1.99988C9.55222 1.99988 9.99994 2.44759 9.99994 2.99988Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2928 17.7071C14.9022 17.3166 14.9022 16.6834 15.2928 16.2929L19.5857 12L15.2928 7.70711C14.9022 7.31658 14.9022 6.68342 15.2928 6.29289C15.6833 5.90237 16.3165 5.90237 16.707 6.29289L21.707 11.2929C22.0975 11.6834 22.0975 12.3166 21.707 12.7071L16.707 17.7071C16.3165 18.0976 15.6833 18.0976 15.2928 17.7071Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99994 12.0001C7.99994 11.4478 8.44765 11.0001 8.99994 11.0001H20.9999C21.5522 11.0001 21.9999 11.4478 21.9999 12.0001C21.9999 12.5524 21.5522 13.0001 20.9999 13.0001H8.99994C8.44765 13.0001 7.99994 12.5524 7.99994 12.0001Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutOutline);
export default __webpack_public_path__ + "static/media/logout-outline.46a9a0db.svg";
export { ForwardRef as ReactComponent };